<template>
    <div class="pay-later">
        <div id="preloader" v-if="load" class="preloader"></div>
        <b-modal
            no-enforce-focus
            content-class="modal-payout-offer"
            id="modal-payment"
            size="lg"
            hide-footer
            centered
        >
            <template #modal-header>
                <div class="header-container">
                    <p class="modal-payout-title">Pay the Artist</p>
                    <div class="modal-event-info">
                        <div class="modal-artist-info">
                            <div class="row-name">Artist</div>
                            <div class="row-value">{{ artistName }}</div>
                        </div>
                        <div class="payout-input-wrapper">
                            <label for="payout" class="payout-label">
                                How much would you like to pay?
                            </label>
                            <span v-if="form.payout !== null" class="dollar-sign">$</span>
                            <input v-model="form.payout" type="number" class="payout-input" />
                        </div>
                        <hr class="divider" />
                        <div class="modal-artist-info flex-column">
                            <div class="total-payment">
                                <div class="row-name">You Pay</div>
                                <div class="row-value">${{ venuePays }}</div>
                            </div>
                            <ul class="payment-info-row">
                                <li>
                                    <div class="payout-info">
                                        <div class="artist-gets">Artist Fees</div>
                                        <div class="artist-gets-payout">
                                            ${{ actualPayout }}
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="payout-info">
                                        <div class="artist-gets">Hedlyner Fees</div>
                                        <div class="artist-gets-payout">
                                            ${{ hedlynerFees }}
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>
            <div class="d-flex flex-column modal-wrapper">
                <PaymentFields
                    :payment-methods.sync="paymentFields.paymentMethods"
                    :card-stripe-id.sync="paymentFields.cardStripeId"
                    @add-new-card="(val) => (addNewCard = val)"
                />
                <div class="agree-policy-main">
                    <div>
                        <input
                            type="radio"
                            name="agreeCheck"
                            v-model="agreement"
                            @change="toggleAgreement"
                        />
                    </div>
                    <div>
                        <span class="agree-policy">
                            By selecting “Pay” below, I agree to Hedlyner's Terms of Service,
                            Payment Terms, Refunds & Cancellation Policy, Dispute Resolution
                            Policy and Off-Platform Policy
                        </span>
                    </div>
                </div>
                <div class="btn-block">
                    <button
                        :class="{
                            'disabled-btn': disabledSaveBtn
                        }"
                        :disabled="disabledSaveBtn"
                        @click="sendPayment"
                    >
                        Pay
                    </button>
                    <button class="cancel-btn" @click="() => $emit('update:show', false)">
                        Cancel
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import PaymentFields from '@/components/payment-methods/PaymentFields.vue'
    import { api } from '@/helpers/api'
    import { notification } from '@/helpers/notification'

    export default {
        name: 'PayLater',
        components: {
            PaymentFields
        },
        props: {
            show: {
                type: Boolean,
                required: true
            },
            artistName: {
                type: String,
                required: true
            },
            artistId: {
                type: Number,
                required: true
            },
            bidArtistId: {
                type: Number,
                required: true
            },
            bidId: {
                type: Number,
                required: true
            },
            venueFee: {
                type: Number,
                required: false,
                default: 0
            }
        },
        emits: ['update:show'],
        data: () => ({
            form: {
                payout: 0
            },
            paymentFields: {
                paymentMethods: [],
                cardStripeId: ''
            },
            addNewCard: false,
            agreement: false,
            load: false
        }),
        computed: {
            request() {
                return {
                    artist_id: this.artistId,
                    bid_id: this.bidId,
                    price: this.venuePays,
                    payment: this.paymentFields.cardStripeId
                }
            },
            actualPayout() {
                try {
                    return parseFloat(this.form.payout)
                } catch {
                    return 0
                }
            },
            venuePays() {
                return this.actualPayout + this.actualPayout * this.venueFee
            },
            hedlynerFees() {
                return this.actualPayout * this.venueFee
            },
            disabledSaveBtn() {
                return (
                    !(this.paymentFields.paymentMethods.length && this.agreement) ||
                    this.addNewCard
                )
            }
        },
        watch: {
            show: {
                handler: function (val) {
                    if (val) {
                        this.$bvModal.show('modal-payment')
                    } else {
                        this.$bvModal.hide('modal-payment')
                    }
                },
                immediate: true
            }
        },
        methods: {
            toggleAgreement() {
                this.agreement = !this.agreement
            },
            async sendPayment() {
                this.load = true
                try {
                    const data = await api({
                        method: 'post',
                        url: `/api/events/manage/${this.bidArtistId}/pay-later`,
                        data: this.request
                    })
                    notification('success', data.message)
                    this.$emit('update:show', false)
                    this.$root.$emit('payment-added')
                } finally {
                    this.load = false
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }
    .header-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        width: 100%;
    }

    .modal-payout-title {
        color: #f5f5f5;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .modal-event-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
    }

    .row-name {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }
    .row-value {
        color: #c9cd00;
        text-align: right;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }
    .row-value-add {
        color: #f5f5f5;
        text-align: right;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .payment-info-row {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
        color: #f5f5f5;
        padding-left: 20px;
    }
    .payout-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .total-payment {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }

    .artist-gets {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .artist-gets-payout {
        color: #f5f5f5;
        text-align: right;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .divider {
        width: 100%;
        color: #646464;
    }
    .modal-wrapper {
        gap: 32px;
    }
    .agree-policy-main {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
    }

    input[type='radio'] {
        height: 20px;
        width: 20px;
        background: inherit;
        appearance: none;
        border: 1px solid #8b8b8b;
        border-radius: 50%;
        min-height: 0;
    }
    input[type='radio']:checked {
        accent-color: #cdeb09;
        appearance: auto;
    }
    .modal-artist-info {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        width: 100%;
        gap: 8px;
    }

    .agree-policy {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .btn-block {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
    }

    button {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        width: 100%;
        border: 0;
    }
    .cancel-btn {
        color: #8b8b8b;
        text-align: center;
        font-family: 'Studio Pro';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        text-decoration-line: underline;
        cursor: pointer;
    }
    .payout-input-wrapper {
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 100%;
        position: relative;
    }
    .payout-input {
        padding: 12px 16px 16px 16px;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        overflow: hidden;
        color: #dedede;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        align-self: stretch;
        width: 100%;
        -moz-appearance: textfield;
        appearance: textfield;
    }
    .payout-input::-webkit-outer-spin-button,
    .payout-input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .payout-input::placeholder {
        overflow: hidden;
        color: #646464;
        text-overflow: ellipsis;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%;
    }
    .payout-label {
        padding: 4px 2px;
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .dollar-sign {
        position: absolute;
        left: 7px;
        top: 43px;
        color: #dedede;
        text-overflow: ellipsis;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%;
    }
</style>
